// New-look minimum text sizes, applied as a JSS plugin so the ~200 hard-coded small `fontSize` values
// across staff-fe's style files don't each need a new-look override. Classic's JSS instance doesn't use it.
// Nothing renders under 12px; small body text (12–13px) reads at 14px; uppercase labels stop at 12px.
const CAPS_MIN = 12;
const BODY_MIN = 14;
const ROOT_FONT_SIZE = 16;
const SIZE = /^\s*(\d*\.?\d+)\s*(px|rem)?\s*(!important)?\s*$/;

const toPx = (value) => {
  const match = typeof value === 'number' ? [null, String(value)] : SIZE.exec(value ?? '');
  if (!match) {
    return null;
  }
  const size = Number(match[1]);
  return { px: match[2] === 'rem' ? size * ROOT_FONT_SIZE : size, important: match[3] ?? '' };
};

export const reskinTextSize = (fontSize, { uppercase = false } = {}) => {
  const parsed = toPx(fontSize);
  // A 0 size hides text on purpose; leave it.
  if (!parsed || parsed.px === 0 || parsed.px >= BODY_MIN) {
    return fontSize;
  }
  const { px, important } = parsed;
  let resized = BODY_MIN;
  if (px < CAPS_MIN) {
    resized = CAPS_MIN;
  } else if (uppercase) {
    return fontSize;
  }
  return important ? `${resized}px ${important}` : resized;
};

const reskinTextSizesPlugin = () => ({
  onProcessStyle(style) {
    if (!style || style.fontSize === undefined) {
      return style;
    }
    const fontSize = reskinTextSize(style.fontSize, { uppercase: style.textTransform === 'uppercase' });
    if (fontSize === style.fontSize) {
      return style;
    }
    // A fixed pixel line height was sized for the old font; scale it so wrapped lines don't overlap.
    const lineHeight = toPx(style.lineHeight);
    if (!lineHeight || typeof style.lineHeight === 'number') {
      return { ...style, fontSize };
    }
    const scale = toPx(fontSize).px / toPx(style.fontSize).px;
    return {
      ...style,
      fontSize,
      lineHeight: `${Math.round(lineHeight.px * scale)}px${lineHeight.important ? ' !important' : ''}`
    };
  }
});

export default reskinTextSizesPlugin;
